const COMPONENT_PREFIX = 'edit-team-name'

export const NAME_FIELD = `${COMPONENT_PREFIX}-field`
export const EMPTY_NAME_ERROR = 'Team name cannot be empty'
export const MAX_LENGTH_ERROR = 'Team name cannot exceed 20 characters'
export const SAVE_BUTTON = `${COMPONENT_PREFIX}-save`
export const SAVE_BUTTON_TEXT = 'Save'
export const CANCEL_BUTTON = `${COMPONENT_PREFIX}-cancel`
export const CANCEL_BUTTON_TEXT = 'Cancel'
export const RENAME_TEAM_FAIL = 'Failed to update team'
export const RENAME_TEAM_SUCCESS = 'Successfully updated team'
